<template>
  <v-container
  v-if="isInEditorMode"
    @click.stop="selectComponent(model)"
    @contextmenu="onShowContextMenu"
    :class="
      evaluateClasses(
        classes,
        'dr-grid-layout',
        isInEditorMode ? 'dr-grid-layout-editor-mode pt-0 pb-0' : '',
        isSelectedGrid() ? 'dr-grid-layout-selected' : ''
      )
    "
    :fluid="fluid"
  >
    <portal to="action-buttons" v-if="isSelectedGrid()">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            :disabled="readonly"
            v-on="on"
            text
            color="error"
            @click="deleteGrid"
          >
            <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg" />
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>
    </portal>
    <draggable
      v-if="isInEditorMode"
      :class="[evaluateClasses(classes), 'draggable-target-grid']"
      :swapThreshold="0.95"
      :emptyInsertThreshold="20"
      :group="{ name: 'grid' }"
      :disabled="readonly"
      @add="onWidgetDraggableAdd"
      @update="onModelChanged"
      @change="onDraggableChanged"
      @start="onStartDraggable"
      :list="rows"
    >
      <!-- строки -->
      <dr-grid-layout-row
        v-for="row in rows"
        :key="row.$ID"
        :class="[evaluateClasses(classes), 'draggable-target-grid']"
        :parentsWidgets="currentListOfParentsWidgets"
        :model="row"
        :readonly="readonly"
        @modelChanged="onModelChanged"
        @deleteRow="onDeleteRow"
        @addRow="onAddRow"
      >
      </dr-grid-layout-row>
    </draggable>
    

    <!-- Контекстное меню -->
    <widgets-context-menu
      v-if="isInEditorMode"
      v-model="showContextMenu"
      :x="x"
      :y="y"
      :widgetModel="model"
      :snippetCreatable="!isInSnippetEditor"
      @createSnippet="onCreateSnippet"
      @deleteComponent="onDeleteComponentFromContextMenu"
      @pasteCopiedWidget="onPasteCopiedWidget"
    />
  </v-container>
  <v-container :fluid="fluid" v-else-if="isVisible" >
    <dr-grid-layout-row
      :key="row.$ID"
      v-for="row in rows"
      :parentDataWidget="parentDataWidget"
      :dataSource="dataSource"
      @callDataSourceAction="$emit('callDataSourceAction', $event)"
      :model="row"
    >
    </dr-grid-layout-row>
  </v-container>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'
import contextMenuMixin from '../../mixins/contextmenu-mixin'
import jsonPatchMixin from '../../mixins/jsonPatchMixin'

export default {
  mixins: [mixin, contextMenuMixin, inputMixin, widgetsWrapperMixin, jsonPatchMixin],
  computed: {
    rows() {
      return (this.model || {}).Rows || []
    },
    fluid() {
      return !!this.model.Fluid
    }
  },
  methods: {
    onModelChanged() {
      this.$emit('modelChanged')
    },
    // Удаление строки из грида
    onDeleteRow(val) {
      this.model.Rows = this.model.Rows.filter((row) => row != val)
      if (!this.model.Rows.length) {
        this.deleteGrid()
        return
      }
      this.onModelChanged()
      this.widgetsHelper.setSelectedWidget(undefined)
    },
    // Добавление строки в грид
    onAddRow() {
      let newRow = {
        $ID: Math.random() + '',
        $Type: 'dr-grid-layout-row',
        Columns: [this.getDefaultColumn(), this.getDefaultColumn()]
      }
      this.model.Rows.push(newRow)
      this.onModelChanged()
    },
    // Если была удалена последняя строка в гриде, то отправляем событие на удаление всего грида
    deleteGrid() {
      this.$emit('deleteComponent', this.model)
    },
    // Возращаем объект свойств колонки по умолчанию
    getDefaultColumn() {
      return {
        $ID: Math.random() + '',
        $Type: 'dr-grid-layout-column',
        Weight: 6,
        Widgets: []
      }
    },
    isSelectedGrid() {
      return this.$store.state[this.stateName].selectedWidget == this.model
    }
  }
}
</script>

<style lang="css">
/* Стили layout */
.dr-grid-layout-editor-mode {
  border: 1px solid #a9a9a9;
  padding-top: 0;
  padding-bottom: 0;
}

.dr-grid-layout-selected {
  outline: 2px solid #ffa500;
  outline-offset: -2px;
}

/* Стили строк */
.dr-grid-layout-row-editor-mode:not(:last-child) {
  border-bottom: 1px solid #a9a9a9;
}
.dr-grid-layout-row-editor-mode {
  margin-top: 15px !important;
  margin-bottom: 0 !important;
  flex-wrap: nowrap !important;
}

.dr-grid-layout-row-header {
  width: 15px;
  background-color: rgba(240, 240, 240);
  border-right: 1px solid #a9a9a9;
  border-top: 1px solid #a9a9a9;
  margin-top: -1px;
  min-width: 15px;
}
.dr-grid-layout-row-header-corner {
  display: none;
  height: 15px;
  background: #fff;
  border-bottom: 1px solid#A9A9A9;
}

.dr-display-row {
  flex-wrap: wrap;
  display: flex;
  flex: 1 1 auto;
}

.dr-grid-layout-row-selected {
  outline: 2px solid #ffa500;
  outline-offset: -2px;
}

/* Стили колонок */

.dr-grid-layout-column-editor-mode:not(:last-child) {
  border-right: 1px solid #a9a9a9;
}
.dr-grid-layout-column-editor-mode:first-child .dr-grid-layout-column-header {
  border-left: 1px solid #a9a9a9;
  margin-left: -1px;
}

.dr-grid-layout-column-editor-mode {
  display: flex;
  flex-direction: column;
  margin-top: -15px;
}

.dr-grid-layout-column-selected {
  outline: 2px solid #ffa500;
  outline-offset: -2px;
}

.dr-grid-layout-column-header {
  text-align: center;
  background-color: #f0f0f0;
  border-bottom: 1px solid darkgrey;
  height: 15px;
  font-size: 0.7em;
}

.column-draggable-target {
  min-height: 50px;
  flex: 1;
}
</style>
